  import React from 'react';
  import './Gauseva.css';
  import { Link, useNavigate } from 'react-router-dom';
  import { FaArrowDown } from "react-icons/fa";






  const Gauseva = () => {

    const navigate = useNavigate(); // ✅ INIT
  const handleDonateClick = () => {
    navigate('/donate-now'); // ✅ ROUTE
  };
    return (
      <div className="gauseva-page">
        {/* Hero Section */}
        <section className="hero">
          <div className="hero-text">
            <h1>Support Gauseva</h1>
            <p>
              Join the sacred mission of Gau Seva — the selfless service and protection of Gomata (Holy Cow), revered in the Vedas as the symbol of purity, abundance, motherhood, and divine energy.

              At Jyotish karmaa Astrology, we believe that caring for cows is not just a tradition, but a spiritual responsibility that brings peace, prosperity, and positive energy into our lives and homes.
            </p>
          </div>
          <img src="/assets/Gauseva/Gauseva8.jpeg" alt="Gauseva" className="hero-img" />
        </section>

        {/* Donation Call Section */}
        <section className="donation-section">
          <img src="/assets/Gauseva/Gauseva4.jpeg" alt="Donate Cow" className="donate-img" />
          <div className="donation-text">
            <h2>Make a Divine Impact</h2>
            <p>
            our small act of kindness can make a lifelong difference. By supporting Gau Seva, you are not just helping a sacred 
            being — you are aligning with dharma, attracting positive energy, and earning spiritual merit for yourself and your family.
            </p>
            <ul>
              <li>🥛 ₹100 – Feed a cow for a day</li>
              <li>🏠 ₹1000 – Shelter support for a month</li>
              <li>💊 ₹2500 – Veterinary care and medicines</li>
            </ul>
            {/* Animated Arrow */}
              <div className="animated-arrow">
                <FaArrowDown />
              </div>
            <button className="donate-btn" onClick={handleDonateClick}>
              Donate Now
            </button>

          </div>
        </section>

        {/* Slideshow Section */}
        <section className="gallery">
          <h2>Life at the Gaushala</h2>
          <p>Peaceful, protected, and spiritual — see how your support nurtures sacred lives.</p>
          <div className="gallery-container">
            <div className="slide"><img src="/assets/Gauseva/Gauseva4.jpeg" alt="Gau Slide 1" /></div>
            
            <div className="slide"><img src="/assets/Gauseva/Gauseva6.jpeg" alt="Gau Slide 3" /></div>
            <div className="slide"><img src="/assets/Gauseva/Gauseva7.jpeg" alt="Gau Slide 1" /></div>
            <div className="slide"><img src="/assets/Gauseva/Gauseva8.jpeg" alt="Gau Slide 2" /></div>
            <div className="slide"><img src="/assets/Gauseva/Gauseva9.jpeg" alt="Gau Slide 3" /></div>
            <div className="slide"><img src="/assets/Gauseva/Gauseva10.jpeg" alt="Gau Slide 3" /></div>
            <div className="slide"><img src="/assets/Gauseva/Gauseva11.jpeg" alt="Gau Slide 3" /></div>
            <div className="slide"><img src="/assets/Gauseva/Gauseva12.jpeg" alt="Gau Slide 3" /></div>
            <div className="slide"><img src="/assets/Gauseva/Gauseva13.jpeg" alt="Gau Slide 3" /></div>
            <div className="slide"><img src="/assets/Gauseva/Gauseva14.jpeg" alt="Gau Slide 3" /></div>
            <div className="slide"><img src="/assets/Gauseva/Gauseva15.jpeg" alt="Gau Slide 3" /></div>

          </div>
        </section>

        {/* Volunteer Section */}
        <section className="volunteer">
          <h2>Be a Gau Sevak</h2>
          <p>
            Step into a life of compassion and spiritual purpose by becoming a Gau Sevak. Offering your time, love, and selfless service to Gomata is one of the highest forms of seva in Sanatan Dharma.

            Whether it’s feeding, cleaning, or simply being in the presence of cows, your seva helps heal—not just them, but your own karma and inner self.
          </p>
           <div className="animated-arrow">
                <FaArrowDown />
              </div>
          <Link to="/contact" className="volunteer-btn">
          Contact Now
        </Link>
        </section>

        {/* Inspirational Quote Section */}
        <section className="quote-section">
          <blockquote>
            “Where cows are worshipped and cared for, prosperity and peace reside.”<br />
            – Ancient Vedic Wisdom
          </blockquote>
        </section>
      </div>
    );
  };

  export default Gauseva;
